import React from 'react';

const C = { navy: '#0D1B2A', slate: '#5C6B7A', green: '#1D9E75', red: '#E24B4A', amber: '#E8A020' };
const fmt$ = v => (v == null ? '—' : `$${Number(v).toLocaleString('en-AU')}`);

// The live book read against the binder's terms: what sits above the per-risk line today, and the highest figure in
// force per class — a hint for what the terms should say, never a figure the platform writes to the register.
export function BinderBookHint({ book, history }) {
  if (!book) return null;
  const last = history?.[0];
  return (
    <div className="mt-3 rounded-sm px-3 py-2" style={{ background: '#F5F7FA' }} data-testid="binder-book-hint">
      <p className="text-[11px]" style={{ color: book.above_limit_total ? C.red : C.green }} data-testid="binder-book-above">
        <span className="font-semibold">{book.above_limit_total}</span> live {book.above_limit_total === 1 ? 'policy sits' : 'policies sit'} above this binder's per-risk line
        {book.above_limit_total ? ' — those binds now refer at the door until the terms say otherwise or the provider approves each one' : ''}
      </p>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1">
        {book.classes.map(c => (
          <span key={c.class} className="text-[10px] font-mono" style={{ color: C.slate }} data-testid={`binder-book-class-${c.class.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`}>
            <span style={{ color: C.navy }}>{c.class}</span>: {c.in_force} in force · highest {c.measure} {fmt$(c.highest_in_force)} · line {fmt$(c.per_risk_limit)}
            {c.per_risk_basis === 'class' ? ' (class)' : c.per_risk_basis === 'binder' ? ' (binder-wide)' : ' (none)'}
            {c.above_limit ? <span style={{ color: C.red }}> · {c.above_limit} above</span> : null}
          </span>
        ))}
      </div>
      {last && (
        <p className="text-[10px] mt-1" style={{ color: C.slate }} data-testid="binder-last-change">
          Last change {new Date(last.at).toLocaleString('en-AU', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })} by {last.by} — {Object.keys(last.changes || {}).join(', ')} — “{last.reason}”
        </p>
      )}
    </div>
  );
}
